import moment from "moment-timezone";

// The window every custom-events fetch must ask for.
//
// The month grid draws whole weeks, so it shows days either side of the month itself. Asking only to
// endOf("month") leaves those spillover cells drawn but empty, and paging away is the only way to
// see what lives there.
//
// isoWeek, not week: moment's default week starts on Sunday, so endOf("week") lands on Saturday and
// cuts the last day the grid draws. The grid runs Monday to Sunday.
//
// Use this everywhere. setCustomEvents REPLACES the store, so one narrower refetch elsewhere throws
// away the events another one loaded.
export const getCustomEventsWindow = ({ fromDate, toDate }) => ({
  start: moment(fromDate)
    .subtract(3, "months")
    .startOf("month")
    .startOf("isoWeek")
    .format("YYYY-MM-DD"),
  end: moment(toDate).endOf("month").endOf("isoWeek").format("YYYY-MM-DD"),
});

export default { getCustomEventsWindow };
